import React, { Component } from 'react';
import img404 from './../images/common-static/error/fourzerofour.svg';
import { Link } from 'gatsby';
import { Helmet } from 'react-helmet';
import Layout from '../components/layout';

export default class Error404 extends Component {
  render() {
    return (
      <Layout>
        <div className="section section-light section-lg">
          <Helmet>
            <html lang="en" />
            <meta name="description" content="Page Not Found" />
            <title>Error</title>
          </Helmet>
          <div className="container">
            <div className="pure-g">
              <div className="pure-u-1 pure-u-md-1-4" />
              <div className="pure-u-1 pure-u-md-1-2 u-c u-align-center">
                <h1 className="hero-logo">
                  <svg className="img" dangerouslySetInnerHTML={{ __html: img404 }} />
                </h1>
                <p>
                  We're sorry. The Web address you entered is not a functioning page on our site. Our homepage is a good
                  place to begin your search for information.
                </p>
                <p className="cta btn-row">
                  <Link to="/" className="btn">
                    Homepage
                  </Link>
                </p>
              </div>
              <div className="pure-u-1 pure-u-md-1-4" />
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}
